module.exports = __webpack_public_path__ + "static/media/04GalleryPuppets.37163fb8.jpeg";